import { render, staticRenderFns } from "./MailingAddress.vue?vue&type=template&id=6f49c5c3&"
import script from "./MailingAddress.vue?vue&type=script&lang=js&"
export * from "./MailingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports